import React, {Component} from 'react';
import {translate} from 'react-i18next';
import classNames from 'classnames';
import * as _ from 'lodash';
import Select from 'react-select';
import CounterView from '../Counter/CounterView';
import PropTypes from 'prop-types';
import {Link, withRouter} from 'react-router-dom';
import {
  calcCostPizza,
  calcCostProduct,
  getCrustOfPizza,
  getFirstCrustWithSize,
  getFormatPrice,
  getSizeOfPizza,
} from '../../helpers';
import {DEFAULT_SIZE_PIZZA} from '../../constants';


class ProductDetailView extends Component {
  constructor(props) {
    super(props);

    this.handleEnter = this.handleEnter.bind(this);
    this.handleLeave = this.handleLeave.bind(this);
    this.handleTouchStart = this.handleTouchStart.bind(this);
    this.onImageLoad = this.onImageLoad.bind(this);
    this.getPrice = this.getPrice.bind(this);
    this.getFooterClasses = this.getFooterClasses.bind(this);
    this.getCurrentCrust = this.getCurrentCrust.bind(this);
    this.getPizzaCrusts = this.getPizzaCrusts.bind(this);
    this.changeOptionsOfProduct = this.changeOptionsOfProduct.bind(this);
    this.increase = this.increase.bind(this);
    this.decrease = this.decrease.bind(this);
    this.getOptions = this.getOptions.bind(this);
    this.isType = this.isType.bind(this);
    this.getProductOptions = this.getProductOptions.bind(this);
    this.getCurrentProductOption = this.getCurrentProductOption.bind(this);
    this.onClickCustomize = this.onClickCustomize.bind(this);
    this.allowChangePizzaSize = this.allowChangePizzaSize.bind(this);

    this.state = {
      quantity: 1,
      selectedQuantity: null,
      selectedCrust: null,
      selectedSize: null,
      selectedSauce: null,
      isImageLoad: false,
      cache: {}
    };
  }

  static getDerivedStateFromProps(props, state) {
    let result = {};
    if (state.cache.type !== props.type || state.cache.productId !== props.product.id) {
      result = {
        cache: {
          type: props.type,
          productId: props.product.id,
        },
        isImageLoad: false,
      }
    }

    return result;
  }

  handleEnter(e) {
    this.props.onMouseEnter(e, {
      id: this.props.product.id,
      type: this.props.type
    });
  }

  handleLeave() {
    this.props.onMouseLeave();
  }

  handleTouchStart(e) {
    if (!this.props.isSelected) {
      this.handleEnter(e)
    } else {
      this.handleLeave()
    }
  }

  onImageLoad() {
    this.setState({
      isImageLoad: true,
    });
  }

  getProductClass() {
    return classNames({
      'product-card': true,
      'product-card--expanded': this.props.isSelected,
    });
  }

  getFooterClasses(product) {
    const emptyOptions = this.isType('deals') || (product.options.length && product.sauces);
    return classNames({
      'product-card__footer': true,
      'product-card__footer--empty-options': !!emptyOptions,
    });
  }

  getPrice(product) {
    const {ingredients} = this.props;
    const {quantity, selectedQuantity} = this.state;
    let cost = 0;
    if (this.isType('pizza')) {
      if (product.options.length > 0) {
        const crustID = this.getCurrentCrust(product);
        const size = this.getCurrentSize(product, crustID);
        cost = calcCostPizza(product, crustID, size, quantity || 1,
          ingredients);
      }
    } else if (this.isType('product')) {
      cost = calcCostProduct(product, selectedQuantity || 1, quantity);
    } else {
      cost = parseFloat(product.price);
    }
    return getFormatPrice(cost);
  }

  getCurrentCrust(product) {
    const {selectedCrust} = this.state;
    const crusts = this.getPizzaCrusts(product);

    const defaultCrustID = crusts.length > 0 ? crusts[0].value : null;

    const crust = crusts.find(obj => {
      return obj.value === selectedCrust;
    });

    if (!!crust) {
      return selectedCrust;
    }

    return defaultCrustID;
  }

  getPizzaCrusts(product) {
    const {language} = this.props;
    const size = this.state.selectedSize || this.getCurrentSize(product);
    const crusts = getCrustOfPizza(product, size, language);

    if (!!this.props.crusts) {
      return crusts.filter(crust => _.includes(this.props.crusts, crust.value));
    }

    return crusts;
  }

  getCurrentSize(product) {
    const {selectedSize} = this.state;
    const {type, isPartOfComposition} = this.props;
    let size = selectedSize;

    if (!size && type === 'pizza') {
      const pizzaSizes = this.getSizeOfPizza(product);
      const pizzaSize = pizzaSizes.find(size => size.value === DEFAULT_SIZE_PIZZA);

      if (pizzaSize && isPartOfComposition === false && product.is_special_pizza) {
        size = pizzaSize.value;
      } else {
        size = pizzaSizes[0].value;
      }
    }

    return size;
  }

  getVisibilitySocial(product) {
    return (!this.props.isSelected || (!this.isType('deals') && !!product.options.length));
  }

  getSizeOfPizza(product) {
    const {selectedCrust} = this.state;
    const {t} = this.props;
    return getSizeOfPizza(product, selectedCrust, this.props.sizes, this.props.crusts, t);
  }

  getParamsForBasket(product) {
    const {selectedCrust, quantity} = this.state;
    const id = product.id;
    const crustId = selectedCrust || getFirstCrustWithSize(product).crust.id;
    return {
      productId: id,
      crustID: crustId,
      quantity: quantity,
      sauceID: product.sauce.id,
      action: 'add',
      size: this.getCurrentSize(product),
    };
  }

  changeOptionsOfProduct(selectedOption, key) {
    this.setState({
      [key]: selectedOption.value,
    });
  }

  increase() {
    const {quantity} = this.state;
    this.setState({
      quantity: quantity + 1,
    });
  }

  decrease() {
    const {quantity} = this.state;
    this.setState({
      quantity: quantity > 1 ? quantity - 1 : 1,
    });
  }

  addToCard(event, product) {
    event.preventDefault();
    const id = product.id;
    const {quantity, selectedCrust, selectedSauce} = this.state;
    const {isSelected, type, history, addToCard, restaurant, language} = this.props;
    if (isSelected) {
      if (this.isType('deals')) {
        history.push(`/${language}/${restaurant.name_for_url}/products/deals/customize/${product.id}`);
      } else {
        let crustId = selectedCrust;
        if (!crustId && type === 'pizza') {
          crustId = this.getCurrentCrust(product);
        }
        let sauceId = selectedSauce;
        if (!sauceId) {
          if (this.isType('pizza')) {
            sauceId = product.sauce ? product.sauce.id : null;
          } else if (product.sauces.length) {
            sauceId = product.sauces[0].sauce.id;
          }
        }
        const data = {
          productId: id,
          quantity: quantity || 1,
          size: this.getCurrentSize(product),
          crustID: crustId,
          sauceID: sauceId,
          optionQuantity: this.getCurrentProductOption(),
          type: type
        };
        addToCard(data);
        this.handleLeave();
      }
    } else {
      this.handleEnter();
    }
  }

  getOptions(options, key) {
    let result = [];
    options.forEach(option => {
      result.push({
        value: option[key].id,
        label: option[key].name,
      });
    });
    return result;
  }

  isType(type) {
    return this.props.type === type;
  }

  getProductOptions() {
    const {product, options, language} = this.props;
    const result = [];

    _.map(product.options, option => {
      const quantity = option.quantity;
      if (!!quantity && (!options || _.includes(options, option.id))) {
        result.push({
          value: quantity.id,
          label: quantity[`name_${language}`],
        });
      }
    });
    return result;
  }

  getCurrentProductOption() {
    const {selectedQuantity} = this.state;
    if (selectedQuantity) {
      return selectedQuantity;
    }
    const options = this.getProductOptions();
    return options.length > 0 ? options[0].value : null;
  }

  onClickCustomize(e, customize, product) {
    e.preventDefault();
    const pathname = '/' + this.props.language + customize.path;
    const to = {
      pathname: pathname,
      state: {
        ...this.getParamsForBasket(product),
      },
    };
    this.props.history.push(to);
  }

  allowChangePizzaSize() {
    const {product, isSelected, isPartOfComposition} = this.props;

    return this.isType('pizza') && isSelected && (isPartOfComposition !== false || !product.is_special_pizza)
  }

  render() {
    const {product, t, language, isSelected, customize, canIncrease, showPrice} = this.props;
    const {quantity, isImageLoad} = this.state;
    let productOptions;

    if (this.isType('product')) {
      productOptions = this.getProductOptions();
    }

    return (
      <div
        className="products__column"
        key={product.id}
        onMouseEnter={this.handleEnter}
        onMouseLeave={this.handleLeave}
      >
        <div className={this.getProductClass()}>
          <div onTouchStart={this.handleTouchStart}>
            <div className={classNames('product-card__image', {
              'product-card__image--transparency': !isImageLoad,
            })}>
              <img src={product.photo_preview_thumbnail} onLoad={this.onImageLoad}
                   alt={product[`name_${language}`]}/>
            </div>
            <div className="product-card__main">
              {showPrice &&
              <div className="product-card__price">{this.getPrice(product)}€
              </div>
              }
              <div
                className="product-card__title">{product[`name_${language}`]}</div>
              <div
                className="product-card__description">{product[`description_${language}`]}</div>
            </div>
          </div>
          <div className="product-card__controls">
            {canIncrease && isSelected &&
            <div className="product-card__counter">
              <CounterView
                increase={this.increase}
                decrease={this.decrease}
                value={quantity}
              />
            </div>
            }
            {!!customize && this.isType('pizza') && isSelected && !product.is_special_pizza &&
            <div className="product-card__link">
              <Link
                to='#'
                onClick={(e) => this.onClickCustomize(e, customize, product)}
              >{t('customizePizza')}</Link>
            </div>
            }
          </div>
          <div className={this.getFooterClasses(product)}>
            {this.getVisibilitySocial(product) &&
            <div className="product-card__socials">
              {/*<span className="icon icon-facebook">*/}
              {/*</span>*/}
            </div>
            }
            {this.allowChangePizzaSize() &&
            <span className="select-panel select-panel--small">
              <label>{t('sizePizza')}</label>
              <Select
                name="form-size-product"
                clearable={false}
                className='Select--small'
                value={this.getCurrentSize(product)}
                onChange={(e) => this.changeOptionsOfProduct(e, 'selectedSize')}
                options={this.getSizeOfPizza(product)}
                searchable={false}
              />
            </span>
            }
            {this.isType('pizza') && isSelected &&
            <span className="select-panel select-panel--small">
              <label>{t('crustPizza')}</label>
              <Select
                name="form-crust-product"
                clearable={false}
                value={this.getCurrentCrust(product)}
                className='Select--small'
                onChange={(e) => this.changeOptionsOfProduct(e, 'selectedCrust')}
                options={this.getPizzaCrusts(product)}
                searchable={false}
              />
            </span>
            }
            {this.isType('product') && isSelected &&
            !!productOptions && productOptions.length > 0 &&
            <span className="select-panel select-panel--small">
              <label>{t('quantityProduct')}</label>
              <Select
                name="form-quantity-product"
                clearable={false}
                className='Select--small'
                value={this.getCurrentProductOption()}
                onChange={(e) => this.changeOptionsOfProduct(e, 'selectedQuantity')}
                options={productOptions}
                searchable={false}
              />
            </span>
            }
            {this.isType('product') && isSelected &&
            !_.isEmpty(product.sauces) &&
            <span className="select-panel select-panel--small">
              <label>{t('sauce')}</label>
              <Select
                name="form-sauce-product"
                clearable={false}
                value={this.state.selectedSauce || product.sauces[0].sauce.id}
                className='Select--small'
                onChange={(e) => this.changeOptionsOfProduct(e, 'selectedSauce')}
                options={this.getOptions(product.sauces, 'sauce')}
                searchable={false}
              />
            </span>
            }
            <button className="product-card__btn" onClick={(e) => this.addToCard(e, product)}>
            </button>
          </div>
        </div>
      </div>
    );
  }
}

ProductDetailView.propTypes = {
  type: PropTypes.string.isRequired,
  product: PropTypes.object.isRequired,
  onMouseEnter: PropTypes.func,
  onMouseLeave: PropTypes.func,
  isSelected: PropTypes.bool,
  language: PropTypes.string.isRequired,
  addToCard: PropTypes.func.isRequired,
  sizes: PropTypes.array,
  crusts: PropTypes.array,
  options: PropTypes.array,
  sauces: PropTypes.array,
  customize: PropTypes.object,
  canIncrease: PropTypes.bool,
  showPrice: PropTypes.bool,
};

export default withRouter(translate('translations')(ProductDetailView));


// WEBPACK FOOTER //
// ./src/components/Product/ProductDetailView.js